import { Controller } from '@hotwired/stimulus';
import { transitionSteps } from '../lib/step_transition';

export default class extends Controller {
  static targets = [
    'noBankAccountStep',
    'bankAccountFormStep',
    'payoutStep',
  ];

  disconnect() {
    if (this.pendingTimeout) {
      clearTimeout(this.pendingTimeout);
      this.pendingTimeout = null;
    }
  }

  showBankAccountForm() {
    const from = this.hasPayoutStepTarget && !this.payoutStepTarget.classList.contains('d-none')
      ? this.payoutStepTarget
      : this.noBankAccountStepTarget;
    this.#transition(from, this.bankAccountFormStepTarget, 'forward');
  }

  backFromForm() {
    const to = this.hasPayoutStepTarget && this.payoutStepTarget.dataset.active === 'true'
      ? this.payoutStepTarget
      : this.noBankAccountStepTarget;
    this.#transition(this.bankAccountFormStepTarget, to, 'backward');
  }

  #transition(outEl, inEl, direction) {
    if (this.pendingTimeout) clearTimeout(this.pendingTimeout);
    this.pendingTimeout = transitionSteps(outEl, inEl, direction);
  }
}
